import { useContext } from 'react'
import { useIntl } from 'react-intl'

import AssistChip from 'LuxKit/Chips/AssistChip'
import LinePaperclipIcon from 'LuxKit/Icons/line/LinePaperclipIcon'
import Group from 'components/utils/Group'
import AttachedDocument from 'tripPlanner/components/Documents/AttachedDocument'
import TripItemInlineNoteEdit from 'tripPlanner/components/ItemCard/TripItemInlineNoteEdit'
import { TripDocumentsContext } from 'tripPlanner/contexts/TripDocumentsContext'
import type { TripItem } from 'tripPlanner/types/tripItem'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'

function NotesAndAttachments({
  item,
  canEdit,
}: {
  item: TripItem
  canEdit: boolean
}) {
  const intl = useIntl()
  const documentContext = useContext(TripDocumentsContext)

  if (item.isSuggested) {
    return null
  }

  const attachedDocuments =
    documentContext?.documentsResult?.attachedFiles[item.id] ?? []

  return (
    <VerticalSpacer gap={12}>
      <BodyText variant="medium" weight="bold">
        {intl.formatMessage({
          id: 'yrWPLsYMA9vj3nCXXEMf',
          defaultMessage: 'Notes and attachments',
          description: 'Heading for the notes and document attachments section of a trip item',
        })}
      </BodyText>
      {attachedDocuments.map((document) => (
        <AttachedDocument key={document.filename} document={document} item={item} />
      ))}
      <Group
        direction="horizontal"
        wrap="wrap-reverse"
        gap="12 8"
        noDisplayWhenEmpty
      >
        <TripItemInlineNoteEdit item={item} />
        {documentContext && canEdit && (
          <AssistChip
            size="small"
            onClick={() => documentContext.onRequestAddDocument(item.id)}
            variant="filled"
            startIcon={<LinePaperclipIcon />}
            className="no-print"
          >
            {intl.formatMessage({
              id: 'GsgWlic93bqUCYWOWd6H',
              defaultMessage: 'Attach document',
              description: 'Button to attach a document to a trip item in the trip planner',
            })}
          </AssistChip>
        )}
      </Group>
    </VerticalSpacer>
  )
}

export default NotesAndAttachments
